import React from 'react';
import { Link, useLocation } from 'react-router-dom';

function Header() {
  const location = useLocation();

  return (
    <header className="header">
      <div className="header-content">
        <Link to="/" className="logo">
          <span className="logo-text">Rob Higareda</span>
        </Link>
        <nav className="nav">
          <Link 
            to="/" 
            className={`nav-link ${location.pathname === '/' ? 'active' : ''}`}
          >
            Home
          </Link>
          <Link 
            to="/resume" 
            className={`nav-link ${location.pathname === '/resume' ? 'active' : ''}`}
          >
            Resume
          </Link>
        </nav>
      </div>
    </header>
  );
}

export default Header;
